import React from "react";

function Footer(){
    return(<div><footer className="section-bg footer-area">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-lg-12">
                <div className="footer-top flex-column">
                    <div className="footer-logo">
                    
                        <h4>Get in Touch</h4>
                    </div>
                    <div className="footer-social">
                        <a href="https://www.facebook.com/profile.php?id=100011191830364" target="_blank"><i className="fa fa-facebook"></i></a>
                        <a href="https://www.linkedin.com/in/damla-eker-49562bb9/" target="_blank"><i className="fa fa-linkedin"></i></a>
                        <a href="https://www.instagram.com/ekerrdamla/" target="_blank"><i className="fa fa-instagram"></i></a>
                        
                    </div>
                </div>
            </div>
        </div>

    </div>
</footer>
</div>)
}

export default Footer